import { PriceSection } from '~/shared/components/Summary/components/PriceSection';
import { Faq } from '~/shared/components/Summary/components/Faq';
import { USPs } from '~/shared/components/Summary/components/USPs';
import { SummaryList } from '~/shared/components/Summary/components/SummaryList';
import { SummaryDesktop } from '~/shared/components/Summary/components/SummaryDesktop';
import { useTranslation } from '~/shared/utils/translation';
import useProducts from '~/features/commerce-api/hooks/useProducts';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { useLocalBasketState } from '~/features/basket/hooks/useLocalBasketState';
import Spacer from '~/theme/design-system/components/Spacer';
import { theme } from '~/theme';
import { UspFaqWrapper } from '~/shared/components/UspFaqWrapper/UspFaqWrapper';
import styles from './CheckoutSummary.module.scss';

type ComponentProps = {
    onSubmit: () => void;
    isCtaDisabled?: boolean;
    isLoading?: boolean;
    ctaLabel: string | undefined;
};

export const CheckoutSummary = ({
    ctaLabel,
    onSubmit,
    isCtaDisabled,
    isLoading,
}: ComponentProps) => {
    const { translate } = useTranslation();
    const { handlers, products } = useProducts();
    const { membership, setMembership } = useLocalBasketState();
    const customer = useCustomer();

    const {
        data: { market },
    } = useFrame();

    // TODO: Possibly prevent duplicate product calls with this.
    // const { data: products } = useQuery({
    //     queryFn: () => handlers.getProducts(),
    //     queryKey: [basketId, ...(productItems?.map((product) => product.productId) ?? [])],
    //     enabled: !!basketId && !!productItems?.length,
    // });

    return (
        <SummaryDesktop>
            <div className={styles.summaryDesktopMain}>
                <SummaryList
                    title={translate('basket.priceSectionTitle')}
                    products={products}
                    showMemberPrice={membership || customer.isPlusMember}
                    large={false}
                />
                <Spacer space={theme.space[4]} />
                <PriceSection
                    ctaLabel={ctaLabel}
                    membership={membership}
                    setMembership={setMembership}
                    signupLabel={
                        (translate('checkout.priceSection.signupLabel.part1'),
                        translate('checkout.priceSection.signupLabel.part2'),
                        translate('checkout.priceSection.signupLabel.part3'))
                    }
                    isLoading={isLoading}
                    onCtaHandler={onSubmit}
                    disabledButton={isCtaDisabled}
                    amountToFreeShipping={handlers.getAmountToFreeShipping()}
                />
            </div>
            <UspFaqWrapper>
                {market?.checkoutUsps && <USPs usps={market?.checkoutUsps} />}

                {market?.checkoutFaq && (
                    <Faq
                        title={translate('checkout.faqSection.title')}
                        faqs={market?.checkoutFaq}
                    />
                )}
            </UspFaqWrapper>
        </SummaryDesktop>
    );
};
